<template>
  <div id="app">
    <router-view />
    <!-- <customer-service v-if="isShow"></customer-service> -->
  </div>
</template>

<script>
import { isLogin } from "@/assets/js/utils";
import customerService from "@/components/customer/customer-service";
export default {
  name: "app",
  data () {
    return {
      isShow: false
    };
  },
  watch: {
    $route (now, old) {
      if (now.path == "/auth/login" || now.path == "/auth/register") {
        this.isShow = false;
      }
    }
  },
  created () {
    if (isLogin()) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },
  components: {
    customerService
  }
};
</script>

<style>
#app {
  font-family: MicrosoftYaHei;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue